export function sendToPosthogError(postHog, eventName, errorPayload) {
  if (!postHog) return;

  const {
    name = "UnknownError",
    message = "An unknown error occurred",
    sessionId = postHog.get_session_id?.(),
    distinctId = postHog.get_distinct_id?.(),
    ...additionalFields
  } = errorPayload;

  postHog.capture(eventName, {
    name,
    message,
    sessionId,
    distinctId,
    ...additionalFields,
  });
}
